export enum CommonFormErrorEnum {
  BLANK = "blank",
  INVALID = "invalid",
  INVALID_EMAIL = "invalidEmail",
  INVALID_PHONE_NUMBER = "invalidPhoneNumber",
  MINIMUM_AGE = "minimumAge",
}

export type Form<FormKey extends string> = {
  state: {
    isValid: boolean;
    values: {
      [name in FormKey]?: string;
    };
    errors: {
      [name in FormKey]?: string | false;
    };
    touched: {
      [name in FormKey]?: boolean;
    };
  };
  helpers: {
    onFieldChange: (name: FormKey, value: string) => void;
    onFieldBlur: (name: FormKey) => void;
    onFieldError: (name: FormKey, error: string | false) => void;
    setErrors: (errors: Partial<Form<FormKey>["state"]["errors"]>) => void;
    performValidation: () => void;
  };
};

export type FormValidator<Keys extends string> = (
  state: Form<Keys>["state"]
) => Partial<Record<Keys, string | false>>;
